import { RegisterForm } from "@/components/Auth/Register.form";
import { useEffect, useState } from "react";
import { SignupHeader } from "@/components/Page/Header/SignupHeader";
import { useHeaderContext } from "@/hooks/useHeaderContext";
import { captureException } from "@/services/sentry";
import { RegistrationSuccess } from "@/components/Auth/RegistrationSuccess";
import { useIsGuest } from "@/hooks/useIsGuest";

export const RegisterPage = () => {
  const { setHeaderContent } = useHeaderContext();
  const [success, setSuccess] = useState(false);
  useIsGuest();

  useEffect(() => {
    setHeaderContent(<SignupHeader />);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  const onSubmit = async () => {
    try {
      setSuccess(true);
    } catch (error) {
      captureException(error);
      console.error(error);
    }
  };
  return (
    <div className="m-auto flex flex-col gap-4 bg-slate-900 text-slate-100">
      {success ? <RegistrationSuccess /> : <RegisterForm onSubmit={onSubmit} />}
    </div>
  );
};
